export default {
  SET_GIFT: '[gift] set gift',
  OPEN_POPUP: '[gift] open popup',
  CLOSE_POPUP: '[gift] close popup',
  RECEIVE: '[gift] receive',
  COPY_HREF: '[gift] copy href popup',
  SET_SHARE_COMPONENT: '[gift] set share component'
}
